var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 11,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.185 5.042a.658.658 0 000 .916l4.737 4.852a.62.62 0 00.893 0 .658.658 0 000-.915L1.525 5.5l4.29-4.395a.658.658 0 000-.915.62.62 0 00-.893 0L.185 5.042z",
    fill: "#0DD1C5"
  })));
}
export default SvgBackLink;